// The static site prepares a draft; the visitor sends it in their email app.
export function contactDraft(fields, enquiryLabel) {
  const clean = key => String(fields.get(key) || '').trim();
  const subject = `EVMG enquiry — ${enquiryLabel || 'General'} — ${clean('organisation')}`;
  const body = [
    clean('message'), '',
    `Name: ${clean('name')}`,
    `Organisation: ${clean('organisation')}`,
    ...(clean('role') ? [`Role: ${clean('role')}`] : []),
    `Email: ${clean('email')}`,
    `Enquiry: ${enquiryLabel || 'General'}`,
  ].join('\n');
  return `mailto:contact@evmg.energy?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
